// =====================================================================
// 表示設定（テーマカラー / ダークモード）の localStorage キャッシュ
//
// もともとはショートカット起動時の「認証キャッシュ」として使っていたが、
// (honbuId, roomId) が保存されているかを見るだけで DevTools から誰でも
// 偽装できるため、セキュリティ機構としては廃止した。
// 認証はサーバー側の API アクセストークン（utils/ApiAuth.ts）で行う。
//
// 現在の用途は、URL に color / mode が付いていない起動（デスクトップ
// ショートカット等）でも前回と同じ見た目で開けるようにするための
// 表示設定の記憶のみ。キー名は既存データとの互換のため変更していない。
// =====================================================================

import type { PaletteColor } from "../types/PaletteColor.ts";

/** localStorage のキー接頭辞（既存データとの互換のため名称を維持） */
export const AUTH_KEY_PREFIX = "taskapp_auth_";

/** (honbuId, roomId) ごとに記憶する表示設定 */
export type StoredAuth = {
  honbuId: number;
  roomId: number;
  color: PaletteColor;
  isDarkMode: boolean;
};

function getAuthKey(honbuId: number, roomId: number): string {
  return `${AUTH_KEY_PREFIX}${honbuId}_${roomId}`;
}

/** 保存済みの表示設定を読み出す。認証状態の判定には使わないこと */
export function loadStoredAuth(honbuId: number, roomId: number): StoredAuth | null {
  try {
    const raw = localStorage.getItem(getAuthKey(honbuId, roomId));
    if (!raw) return null;
    return JSON.parse(raw) as StoredAuth;
  } catch {
    return null;
  }
}

/** 表示設定を保存する（次回同じルームを開いたときの初期値に使う） */
export function saveStoredAuth(auth: StoredAuth): void {
  localStorage.setItem(getAuthKey(auth.honbuId, auth.roomId), JSON.stringify(auth));
}
